import React, { useEffect, useState } from 'react';
import * as HELPER from "../../src/config/helper";
import { useLanguage } from '../../src/context/LanguageContext';
import Pagination from '../../src/common/Pagination';
import { MANAGER_LEVEL_IDS } from '../../src/config/constant';
import secureStorage from '../../src/config/encrypt';
import { REMITTANCE_STATUS, ROLE_FEATURES } from "../config/ph/constant";
import { updateLeadAssignUser } from '../../src/store/slices/insurance';
import { useNavigate } from 'react-router-dom';
import {ADMIN_OPS_STATUS,ADMIN_MAKER_STATUS,ADMIN_CHECKER_COMPLETE_STATUS,COUNTRY_CODE,APP_COUNTRY,FLAT_DISBURSMENT_FEES} from '../config/constant';
import DynamicTable from '../component/table/DynamicTable';
import { tables } from '../config/switch';
import LeadHistoryModal from '../lead/common/LeadHistoryModal';

interface SelectedLead {
  lead_id: number;
  remittance_status: number | null;
  remittance_type_id: number | null;
  remittance_type_name : string | null;
  assign_to:string
}

const RemittanceListTable: React.FC<any> = ({config, remittanceList ,paginationData, selectedFilters, getRemittanceListing, assignUsers,selectedLeads,setSelectedLeads,isAllLeadsSelected,setIsAllLeadsSelected }) => {
    const { translations } = useLanguage();
    const page = 1;
    // const [selectAll, setSelectAll] = useState(false);
    const [remittanceListData, setRemittanceListData] = useState<any>([]);
    const authUserInfo = secureStorage.getItem("authUserInfo");
    const [showSelectedAssignSave, setShowSelectedAssignSave] = useState<any>({});
    const navigate = useNavigate();
    const [viewTimeLine, setViewTimeLine] = useState(false);
    const [selectedRemarkLead, setSelectedRemarkLead] = useState<any>(0);

     useEffect(() => {
        setRemittanceListData(remittanceList);
    }, [remittanceList])

    const handleRequestData = (params: any) => {
        let apiParams = {
            ...selectedFilters,
            ...params,
            page_number: params.page_no
        }

        getRemittanceListing(apiParams);
    }


    // Handle individual checkbox change
    const handleItemSelect = (lead: { lead_id: number; remittance_status: number | null; remittance_type_id: any, remittance_type_name: string | null },isChecked: boolean): void => {
        let getLead: any = remittanceListData.find((ins: any) => ins.leadId === lead.lead_id && ins.remittance_type_id === lead.remittance_type_id) || {};
        if (isAllLeadsSelected) {
            setIsAllLeadsSelected(false);
        }
        if (isChecked) {
            setSelectedLeads((prev:any) => [
                ...prev,
                {
                    lead_id: lead.lead_id,
                    remittance_status: lead.remittance_status,
                    remittance_type_id: lead.remittance_type_id,
                    remittance_type_name : lead.remittance_type_name,
                    assign_to : getSelectedRole(getLead,lead.remittance_type_id)?.label
                },
            ]);
        } else {
            setSelectedLeads((prev:any) =>
                prev.filter(
                    (item:any) =>
                    !(
                        item.lead_id === lead.lead_id &&
                        item.remittance_type_id === lead.remittance_type_id
                    )
                )
            );
        }
    }

    // Handle select all checkbox
    const handleSelectAll = (isChecked: boolean) => {
        setIsAllLeadsSelected(isChecked);
        if (isChecked) {
            // select all
            const allSelected: SelectedLead[] = remittanceList.map((lead: any) => ({
                lead_id: lead.leadId,
                remittance_status: lead.remittance_status ?? null,
                remittance_type_id: lead.remittance_type_id ?? null,
                remittance_type_name : lead.remittance_type_slug ?? null,
                assign_to : getSelectedRole(lead,lead.remittance_type_id)?.label
            }));
            setSelectedLeads(allSelected);
        } else {
            // unselect all
            setSelectedLeads([]);
        }
    };

    const getSelectedAssignUser = (lead:any,remittance_type_id:number) => {  
        if (!lead || !assignUsers?.length) return null;
        let userId:any = null;
        if (ADMIN_OPS_STATUS.includes(lead.remittance_status) && lead.ops_id && +lead.remittance_type_id === remittance_type_id) {
            userId = lead.ops_id;
        } else if (ADMIN_MAKER_STATUS.includes(lead.remittance_status) && lead.maker_id && +lead.remittance_type_id === remittance_type_id) {
            userId = lead.maker_id;
        } else if (ADMIN_CHECKER_COMPLETE_STATUS.includes(lead.remittance_status) && lead.checker_id && +lead.remittance_type_id === remittance_type_id) {
            userId = lead.checker_id;
        }
        if (!userId) return null;
        const filterdUser = getFilteredUsers(lead,remittance_type_id)
        const selectedUser = filterdUser.find((u:any) => +u.value === +userId);
        return selectedUser || null;
    }

    const handleChangeAssign = (leadId: any,remittance_type_id:any, e: any) => {
        // setRemittanceListData(remittanceList.map((u: any) => { return (u.leadId === leadId && u.remittance_type_id === remittance_type_id) ? { ...u, 'ops_id': e.value } : u }));
        setRemittanceListData((prevList: any[]) =>
            prevList.map((lead: any) => {
                if (lead.leadId === leadId && +lead.remittance_type_id === +remittance_type_id) {
                    let updatedLead = { ...lead };
                    if ([REMITTANCE_STATUS.READY_FOR_OPS, REMITTANCE_STATUS.BACK_TO_OPS].includes(lead.remittance_status)) {
                        updatedLead.ops_id = e?.value || null;
                    } else if ([REMITTANCE_STATUS.READY_FOR_MAKER, REMITTANCE_STATUS.BACK_TO_MAKER].includes(lead.remittance_status)) {
                        updatedLead.maker_id = e?.value || null;
                    } else if ([REMITTANCE_STATUS.READY_FOR_CHECKER, REMITTANCE_STATUS.COMPLETE].includes(lead.remittance_status)) {
                        updatedLead.checker_id = e?.value || null;
                    }
                    return updatedLead;
                }
                return lead;
            })
        );
        setShowSelectedAssignSave({lead_id:leadId,remittance_type_id:remittance_type_id});
    }

    const detailPageRedirect = (id:number,remittance_type_slug:string) => {
        navigate(`/remittance-details/${id}/${remittance_type_slug}`);
    }

     const saveAssignLeadHandler = (params: { id: string, action: string }) => {
            if (params.action === "cancel") {
                setShowSelectedAssignSave({});
                setRemittanceListData([...remittanceList])
            } else {
                let getLead: any = remittanceListData.find((ins: any) => ins.id === params.id) || {};
                const selectedRole:any = getSelectedRole(getLead, +getLead.remittance_type_id);
                let assigned_user_id = getLead?.ops_id || null;
                let assigned_user_type = "ops";
                if (selectedRole) {
                    switch (selectedRole.slug) {
                        case "rem-finance-maker":
                            assigned_user_id = getLead?.maker_id || null;
                            assigned_user_type = "maker";
                            break;
                        case "rem-finance-checker":
                            assigned_user_id = getLead?.checker_id || null;
                            assigned_user_type = "checker";
                            break;
                        default:
                            assigned_user_id = getLead?.ops_id || null;
                            assigned_user_type = "ops";
                    }
                }
                updateLeadAssignUser({ lead_id: params.id, "assigned_user_id": assigned_user_id,isRemittance:true,assigned_user_type }).then((res: any) => {
                    if(res && res.status === 200) {
                      handleRequestData({page_no: 1});                              
                      setShowSelectedAssignSave({})
                    }
                }).catch(err => {
    
                })
            }
      }

    const calculateRemittanceAmount = (remittanceDetail: any): string => {
        let amount = 0;
        if(COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH){
            switch (remittanceDetail.remittance_type) {
                case "Partner":
                    amount = Number(remittanceDetail.actual_remittance || 0) -
                            (Number(remittanceDetail.premium_paid || 0) +
                            Number(remittanceDetail.remittance_amount || 0));
                    break;
                case "Agency":
                    amount = Number(remittanceDetail.actual_remittance || 0) -
                            (Number(remittanceDetail.remittance_amount || 0) +
                            Number(remittanceDetail.amount_received_from_agency || 0));
                    break;
                case "Referral":
                    amount = Number(remittanceDetail.referral_payout_Actual || 0) -
                            Number(remittanceDetail.referral_remmitted_already || 0);
                    break;
                default:
                    amount = Number(remittanceDetail.remittance_amount || 0);
            }
        }else{
            switch (remittanceDetail.remittance_type) {
                case "Partner":
                    amount = Number(remittanceDetail.gross_written_premium || 0) + (Number(remittanceDetail.admin_fee || 0) + Number(remittanceDetail.disbursement_fees || 0));
                    break;
                case "Agency-Commission":
                    // amount = Number(remittanceDetail.net_commission_disbursal || 0) + FLAT_DISBURSMENT_FEES;
                    amount = Number(remittanceDetail.net_commission_disbursal || 0) + Number(remittanceDetail?.disbursement_fees || 0);
                    break;
                case "Agency-Points":
                    // amount = Number(remittanceDetail.net_point_disbursal || 0) + FLAT_DISBURSMENT_FEES;
                    amount = Number(remittanceDetail.net_point_disbursal || 0) + Number(remittanceDetail?.disbursement_fees || 0);
                    break;
                default:
                    amount = Number(remittanceDetail.remittance_amount || 0);
            }
        }
        return HELPER.addCurrencyFormatting(amount.toFixed(2));
    };

    const getSelectedRole = (lead:any,remittance_type_id:number) => {
        // if (selectedRoles[lead.leadId]) return selectedRoles[lead.leadId];
        if (!lead || !config["remittance_roles"]) return null;
        const roles = config["remittance_roles"];
        // Rem Ops
        if (ADMIN_OPS_STATUS.includes(lead.remittance_status) && lead.ops_id && +lead.remittance_type_id === remittance_type_id) {
            return roles.find((r:any) => r.slug === "rem-ops") || null;
        }

        // Rem Finance Maker
        if (ADMIN_MAKER_STATUS.includes(lead.remittance_status) && lead.maker_id && +lead.remittance_type_id === remittance_type_id) {
            return roles.find((r:any) => r.slug === "rem-finance-maker") || null;
        }

        // Rem Finance Checker
        if (ADMIN_CHECKER_COMPLETE_STATUS.includes(lead.remittance_status) && lead.checker_id && +lead.remittance_type_id === remittance_type_id) {
            return roles.find((r:any) => r.slug === "rem-finance-checker") || null;
        }
        return null;
    }

    const getFilteredUsers = (lead:any,remittance_type_id:number) => {
        const selectedRole = getSelectedRole(lead,remittance_type_id); // from your previous role logic

        if (!selectedRole) return assignUsers.filter((u:any) => u.role_slug === "rem-ops");

        // Filter assignUsers by role_slug directly
        return assignUsers.filter((u:any) => u.role_slug === selectedRole.slug);
    };

    const handleViewTimeLine = (type: boolean, leadId: number) => {    
      setViewTimeLine(type);
      setSelectedRemarkLead(leadId);
    }

    return (
        <>
            <div className="data-table lead-list-table remittance-list-table">
                <DynamicTable
                    columns={tables.getRemittanceTable(translations)}
                    data={remittanceListData}
                    translations={translations}
                    conditions={{
                        isManager: MANAGER_LEVEL_IDS.includes(
                        authUserInfo?.user_data?.assigned_role_ids
                        ),
                    }}
                    isAllSelected={isAllLeadsSelected}
                    handleSelectAll={handleSelectAll}
                    helper={{
                        ...HELPER,
                        isItemSelected: (row: any) =>
                        selectedLeads.some(
                            (item: any) =>
                            item.lead_id === row.leadId &&
                            item.remittance_type_id === row.remittance_type_id,
                        ),
                        handleItemSelect,
                        calculateRemittanceAmount,
                        getSelectedRole,
                        getSelectedAssignUser,
                        getFilteredUsers,
                        handleChangeAssign,
                        showSelectedAssignSave,
                        saveAssignLeadHandler,
                        viewRemittanceDetails: (row: any) =>
                        detailPageRedirect(row.hashId, row.remittance_type_slug),
                        viewTimeline: (row: any) => handleViewTimeLine(true, row.leadId),
                    }}
                    roleFeatures={ROLE_FEATURES}
                    />

                {(paginationData && paginationData['total'] > 10) && <Pagination paginateData={{
                    page,
                    loading: false,
                    totalLengthWithoutPagination: paginationData['total'],
                    paginationData,
                    filteredData: selectedFilters
                }}
                    sendRequestDataToParent={handleRequestData} />}
            </div>
            {viewTimeLine && <LeadHistoryModal selectedRemarkLead={selectedRemarkLead} viewTimeLine={viewTimeLine} handleViewTimeLine={handleViewTimeLine} isRemittance={true}/>}
        </>
    );
};

export default RemittanceListTable;